/* app/js/src/components/calendar/calendar-datepicker.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.date-picker {
  display: none;
  position: absolute;
  background: white;
  top: 100%;
  left: 0;
  z-index: 4;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
}
.date-picker.active {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.time-pick {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.time-pick > div {
  display: inline-block;
  width: 50%;
  height: 51px;
  padding: 8px;
  background-color: #eef2f6;
}
.time-pick > div:not(:first-of-type) {
  margin-left: 1px;
}
.time-pick > div.active {
  background-color: white;
}
.time-pick > div.active input {
  background-color: white;
}
.time-pick > div input {
  width: 20px;
  font-family: "Open Sans", sans-serif;
  font-size: 11px;
  letter-spacing: 0.1px;
  text-align: left;
  color: #232f3a;
  outline: none;
  display: block;
  border: none;
  background-color: #eef2f6;
}
.description {
  width: 34px;
  height: 9px;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  letter-spacing: 0.1px;
  text-align: left;
  color: #7d8fa1;
}
datepicker {
  margin-top: 1px;
}
.btn-apply {
  width: 60px;
  height: 28px;
  border-radius: 4px;
  background-color: #232f3a;
  position: relative;
  left: 72%;
  margin-bottom: 8px;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-apply span {
  width: 33px;
  height: 12px;
  font-family: Open Sans;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.1px;
  text-align: left;
  color: #ffffff;
  position: relative;
  left: 14px;
  top: 5px;
}
.btn-apply:hover {
  background-color: #40c4ff;
}
.btn-clear {
  width: 60px;
  height: 28px;
  border-radius: 4px;
  background-color: #232f3a;
  left: 7px;
  top: 37px;
  position: relative;
  margin-bottom: 8px;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-clear span {
  width: 33px;
  height: 12px;
  font-family: Open Sans;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.1px;
  text-align: left;
  color: #ffffff;
  position: relative;
  left: 14px;
  top: 5px;
}
.btn-clear:hover {
  background-color: #40c4ff;
}
.close-calendar {
  cursor: pointer;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  position: absolute;
  left: 238px;
  top: -15px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  z-index: 1;
  background-color: #ffffff;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.close-calendar path {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
.close-calendar:hover path {
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.hour,
.minute {
  position: relative;
}
.hour.active ::ng-deep path,
.minute.active ::ng-deep path {
  fill: black !important;
}
.hour .pencil-icon,
.minute .pencil-icon {
  position: absolute;
  left: 100px;
  top: 27px;
}
.hour .pencil-icon ::ng-deep svg,
.minute .pencil-icon ::ng-deep svg {
  width: 16px;
  height: 16px;
}
.hour .pencil-icon path,
.minute .pencil-icon path {
  fill: #757575;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.hour:hover .pencil-icon path,
.minute:hover .pencil-icon path {
  fill: #232f3a;
}
/*# sourceMappingURL=calendar-datepicker.component.css.map */
